import { calculateRgbaWithAlpha } from 'helpers/colorFormatter';
import {
  OPACITY_13,
  OPACITY_33,
  OPACITY_73,
  OPACITY_100,
  OPACITY_5
} from 'constants/opacity';

// TODO: update names of style utilities to consistent naming convention apply vs get
export const getCardBackgroundColor = theme =>
  calculateRgbaWithAlpha(theme.palette.card.background.main, OPACITY_100);

export const getUpsellBackgroundColor = theme =>
  calculateRgbaWithAlpha(theme.palette.button.background.hover, OPACITY_13);

export const getSectionNavColor = theme =>
  calculateRgbaWithAlpha(theme.palette.sectionNav.link.main, OPACITY_100);

export const getSectionNavMediumColor = theme =>
  calculateRgbaWithAlpha(theme.palette.sectionNav.link.main, OPACITY_73);

export const getSectionNavLightColor = theme =>
  calculateRgbaWithAlpha(theme.palette.sectionNav.link.main, OPACITY_33);

export const getSectionNavLighterColor = theme =>
  calculateRgbaWithAlpha(theme.palette.sectionNav.link.main, OPACITY_13);

export const getSectionNavHoverColor = theme =>
  calculateRgbaWithAlpha(theme.palette.sectionNav.link.hover, OPACITY_100);

export const getMenuItemNamesColor = theme =>
  calculateRgbaWithAlpha(theme.palette.menuItemNames.main, OPACITY_100);

export const getMenuItemNamesMediumColor = theme =>
  calculateRgbaWithAlpha(theme.palette.menuItemNames.main, OPACITY_73);

export const getMenuItemNamesLightColor = theme =>
  calculateRgbaWithAlpha(theme.palette.menuItemNames.main, OPACITY_33);

export const getHeaderLinkMainMediumColor = theme =>
  calculateRgbaWithAlpha(theme.palette.header.link.main, OPACITY_73);

export const getMenuItemNamesLighterColor = theme =>
  calculateRgbaWithAlpha(theme.palette.menuItemNames.main, OPACITY_13);

export const getHeaderLinkColor = theme =>
  calculateRgbaWithAlpha(theme.palette.header.link.main, OPACITY_100);

export const getHeaderLinkMediumColor = theme =>
  calculateRgbaWithAlpha(theme.palette.header.link.main, OPACITY_73);

export const getHeaderLinkLightColor = theme =>
  calculateRgbaWithAlpha(theme.palette.header.link.main, OPACITY_33);

export const getHeaderLinkLighterColor = theme =>
  calculateRgbaWithAlpha(theme.palette.header.link.main, OPACITY_13);

export const getHeaderLinkHoverColor = theme => theme.palette.header.link.hover;

export const getButtonFontColor = theme => theme.palette.button.font.main;

export const getButtonFontHoverColor = theme => theme.palette.button.font.hover;

export const getButtonBackgroundHoverColor = theme =>
  theme.palette.button.background.hover;

export const getButtonBackgroundColor = theme =>
  theme.palette.button.background.main;

export const getButtonBackgroundHoverMediumColor = theme =>
  calculateRgbaWithAlpha(theme.palette.button.background.hover, OPACITY_73);

export const getPageBackgroundColor = theme =>
  theme.palette.page.background.main;

export const getHeaderAccentLightestColor = theme =>
  calculateRgbaWithAlpha(theme.palette.header.accent.main, OPACITY_5);

export const getHeaderAccentMain = theme => theme.palette.header.accent.main;

export function getItemDescriptionsAndPricesTypography(theme) {
  const {
    fontFamily,
    fontWeight,
    letterSpacing
  } = theme.typography.itemDescriptionsAndPrices;
  return {
    fontFamily,
    fontWeight,
    letterSpacing
  };
}

export function getMenuItemNamesTypography(theme) {
  const {
    fontFamily,
    fontWeight,
    letterSpacing
  } = theme.typography.menuItemNames;
  return {
    fontFamily,
    fontWeight,
    letterSpacing
  };
}

export function getHeaderAndNavigationTypography(theme) {
  const { fontFamily, fontWeight, letterSpacing } = theme.typography.header;
  return {
    fontFamily,
    fontWeight,
    letterSpacing
  };
}

export function getMenuSectionTitlesTypography(theme) {
  const {
    fontFamily,
    fontWeight,
    textTransform
  } = theme.typography.menuSectionTitles;
  return {
    fontFamily,
    fontWeight,
    textTransform
  };
}

export function getHeroTextColor(theme, hasHeroImage) {
  if (!hasHeroImage) {
    return theme.palette?.button?.font?.hover;
  }
  return theme.palette.white;
}
